 export const allocatedCapacityOptions = [
            { value: "10 Gbps", label: "10 Gbps" },
            { value: "20 Gbps", label: "20 Gbps" },
            { value: "30 Gbps", label: "30 Gbps" },
            { value: "40 Gbps", label: "40 Gbps" },
            { value: "50 Gbps", label: "50 Gbps" },
            { value: "60 Gbps", label: "60 Gbps" },
            { value: "70 Gbps", label: "70 Gbps" },
            { value: "80 Gbps", label: "80 Gbps" },
            { value: "90 Gbps", label: "90 Gbps" },
            { value: "100 Gbps", label: "100 Gbps" },
        ]
export const connectivityServiceType =[
  { value: "2G/3G", label: "2G/3G" },
  { value: "4G", label: "4G" },
]
export const selectionType =[
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
]
export const directionOption =[
  { value: "Unilateral Inbound", label: "Unilateral Inbound" },
  { value: "Unilateral Outbound", label: "Unilateral Outbound" },
  { value: "Bilateral", label: "Bilateral" },
]

export const CATEGORY = {
  ON_NET: {
    value: "On-Net",
    label: "On-Net (Vodafone Local Markets)",
  },
  OFF_NET: {
    value: "Off-Net",
    label: "Off-Net (Vodafone Partner Markets + Third Party)",
  },
};
export const NETWORK_TYPES = [
  {
    value: "On-Net",
    label: "On-Net",
  },
  {
    value: "Off-Net",
    label: "Off-Net",
  },
  {
    value: "ANSI",
    label: "ANSI",
  },
];

export const stages = [
  { stage: "Demand", states: ["DEMAND_CREATED"] },
  { stage: "Quotation", states: ["FEASIBILITY_COMPLETED", "PRICING_CREATED", "MARGIN_ADDED", "QUOTATION_GENERATED"] },
  { stage: "Order Form", states: ["ORDER_FORM_DRAFTED", "ORDER_FORM_REVIEWED_INTERNAL", "ORDER_FORM_GENERATED"] },
  { stage: "Service Building", states: ["PROVISIONING_COMPLETED"] },
  { stage: "Billing Onboarding", states: ["FINCA_ONBOARDING_COMPLETED"] },
  { stage: "Go Live", states: ["DEMAND_COMPLETED"] }
 ];
export const normalize = (s) => (typeof s === "string" ? s.trim() : "");

export function buildRegionCountryOptions(locations = []) {
  const byRegion = new Map();    
  const regionMeta = new Map();  

  for (const loc of locations ?? []) {
    const country = normalize(loc?.country);
    const rVal = normalize(loc?.region?.value);
    const rLabel = normalize(loc?.region?.label);
    if (!rVal || !rLabel || !country) continue;

    if (!byRegion.has(rVal)) byRegion.set(rVal, new Set());
    byRegion.get(rVal).add(country);

    if (!regionMeta.has(rVal)) {
      regionMeta.set(rVal, { value: rVal, label: rLabel });
    }
  }

  const regionList = Array.from(regionMeta.values())
    .sort((a, b) => a.label.localeCompare(b.label));

  const countryMap = {};
  for (const [rVal, set] of byRegion.entries()) {
    countryMap[rVal] = Array.from(set)
      .sort((a, b) => a.localeCompare(b))
      .map((c) => ({ value: c, label: c }));
  }
  return { regionList, countryMap };
}

export function getCountryOptionsByRegion(locations = [], regionValue) {
  const { countryMap } = buildRegionCountryOptions(locations);
  const key = normalize(regionValue);
  return countryMap[key] ?? [];
}

export function getRegionOptions(locations = []) {
  return buildRegionCountryOptions(locations).regionList;
}

export const filterRowForSubmit = (row) => {
  switch (row.service) {
    case "DNS":
      return {
        organization: row.organization,
        service: row.service,
        location: row.location,
        country: row.country,
        dns_number:row.dns_number,
        comment: row.comment,
        files: row.files,
      };
    case "SIGTRAN":
      return {
        organization: row.organization,
        service: row.service,
        location: row.location,
        country: row.country,
        checkBox:row.checkBox,
        comment: row.comment,
        files: row.files,
        avg_monthly_msu_volumes: row.avg_monthly_msu_volumes,
        top_destinations: row.top_destinations,
      };
    case "DIAMETER":
      return {
        organization: row.organization,
        service: row.service,
        location: row.location,
        country: row.country,
        avg_monthly_dtr_volumes: row.avg_monthly_dtr_volumes,
        comment: row.comment,
        files: row.files,
      };
    case "TRANSPORT":
      return {
        organization: row.organization,
        service: row.service,
        location: row.location,
        country: row.country,
        allocated_capacity: row.allocated_capacity,
        comment: row.comment,
        files: row.files,
      };
    case "VOLTE":
      return {
        organization: row.organization,
        service: row.service,
        roamingPartnerTadigId: row.roamingPartnerTadigId,
        requestorCountry: row.requestorCountry,
        requestorTadig: row.requestorTadig,
        requestorOrganisationName: row.requestorOrganisationName,
        direction: row.direction,
        country: row.country,
        roamingPartnerName: row.roamingPartnerName,
        files: row.files,
      };
    default:
      return { service: row.service };
  }
};